/******************************************************************
 * Archivo : client/src/components/App.js
 * Proyecto: CB30
 * Módulo  : Aplicación principal / Rutas
 *
 * Propósito:
 * Definir las rutas principales de CB30 y controlar el acceso
 * inicial de los usuarios autenticados.
 ******************************************************************/

import React, { Component } from "react";
import { graphql } from "react-apollo";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

// Query
import query from "../queries/fetchIsUserActive";

// Styles
import "./styles/spinner.css";
import "./styles/global.css";

// Components: Global
import Header from "./Header/";
import Footer from "./Footer/";
import Dashboard from "./Dashboard";

// Components: User
import User from "./User/";
import BlockedUser from "./User/BlockedUser";
import EditUser from "./User/EditUser";
import UserDetails from "./User/AddUserDetails";
import ChangePassword from "./User/ChangePassword";
import AdminEditUser from "./Admin/users/EditUser";

// Components: Survey
import Survey from "./Survey/consumer/";
import AddSurvey from "./Survey/admin/AddSurvey";
import SurveyList from "./Survey/consumer/SurveyList";
import EditSurveyFields from "./Survey/admin/EditSurveyFields";
import EditFieldCollection from "./Survey/admin/EditFieldCollection";
import SurveyResultReport from "./Admin/reports/SurveyResultReport";


// Components: Admin
import AdminDashboard from "./Admin/";
import AllUsers from "./Admin/users/AllUsers";
import AllRoles from "./Admin/roles/AllRoles";
import RoleForm from "./Admin/roles/RoleForm";
import AllSurveys from "./Admin/surveys/AllSurveys";
import SurveyResults from "./Admin/surveys/Results";
import SurveyViewer from "./Admin/surveys/SurveyViewer";
import ReportsDashboard from "./Admin/reports/ReportsDashboard";
import SurveyCSVExport from "./Admin/reports/SurveyCSVExport";
import ViewDinamic from "./Admin/surveys/ViewDinamic";


class App extends Component {
  render() {
    if (this.props.data.loading) {
      return <div className="loader">Loading...</div>;
    }

    let mustChangePassword = false;

    if (this.props.data.user) {
      const { role, active } = this.props.data.user;

      if (role === "default" && !active) {
        return <BlockedUser />;
      }
    }

    mustChangePassword = this.props.data.user
      ? this.props.data.user.mustChangePassword
      : false;

    return (
      <BrowserRouter>
        <React.Fragment>

          <Header />

          <main style={{ paddingBottom: "60px" }}>

            <Switch>

              <Route
                exact
                path="/dashboard/cambiar-password"
                component={ChangePassword}
              />

              {mustChangePassword ? (

                <Redirect to="/dashboard/cambiar-password" />

              ) : (

                <React.Fragment>

                  <Route
                    exact
                    path="/dashboard"
                    component={Dashboard}
                  />

                  <Route
                    exact
                    path="/dashboard/perfil"
                    component={User}
                  />

                  <Route
                    exact
                    path="/dashboard/perfil/agregar/detalles"
                    component={UserDetails}
                  />

                  <Route
                    exact
                    path="/dashboard/perfil/editar/:id"
                    component={EditUser}
                  />

                  <Route
                    exact
                    path="/dashboard/cambiar-password"
                    component={ChangePassword}
                  />

                  <Route
                    exact
                    path="/dashboard/encuestas"
                    component={SurveyList}
                  />

                  <Route
                    exact
                    path="/dashboard/encuesta/:id"
                    component={Survey}
                  />

                  {/* Administración */}

                  <Route
                    exact
                    path="/admin"
                    component={AdminDashboard}
                  />

                  <Route
                    exact
                    path="/admin/usuarios"
                    component={AllUsers}
                  />

                  <Route
                    exact
                    path="/admin/usuarios/nuevo"
                    component={AdminEditUser}
                  />

                  <Route
                    exact
                    path="/admin/usuario/:id"
                    component={AdminEditUser}
                  />

                  <Route
                    exact
                    path="/admin/roles"
                    component={AllRoles}
                  />

                  <Route
                    exact
                    path="/admin/roles/new"
                    component={RoleForm}
                  />

                  <Route
                    exact
                    path="/admin/roles/:id"
                    component={RoleForm}
                  />

                  {/* Reportes */}

                  <Route
                    exact
                    path="/admin/reportes"
                    render={props => (
                      <ReportsDashboard
                        {...props}
                        user={this.props.data.user}
                      />
                    )}
                  />

                  <Route
                    exact
                    path="/admin/reportes/resultado-encuesta"
                    component={SurveyResultReport}
                  />

                  <Route
                    exact
                    path="/admin/reportes/exportacion-csv-encuesta"
                    component={SurveyCSVExport}
                  />


                  {/* Perfil */}



                  {/* Encuestas */}

                  <Route
                    exact
                    path="/admin/encuestas"
                    component={AllSurveys}
                  />

                  <Route
                    exact
                    path="/admin/encuesta/nueva"
                    component={AddSurvey}
                  />

                  <Route
                    exact
                    path="/admin/resultados/:id"
                    component={SurveyResults}
                  />

                  <Route
                    exact
                    path="/admin/visor"
                    component={SurveyViewer}
                  />

                  <Route
                    exact
                    path="/admin/visordinamico"
                    component={ViewDinamic}
                  />

                  <Route
                    exact
                    path="/admin/encuesta/nueva/:id"
                    component={EditSurveyFields}
                  />

                  <Route
                    exact
                    path="/admin/encuesta/editar/:id"
                    component={EditSurveyFields}
                  />

                  <Route
                    exact
                    path="/admin/encuesta/editar/pregunta/:id"
                    component={EditFieldCollection}
                  />

                </React.Fragment>
              )}

            </Switch>

          </main>

          <Footer />

        </React.Fragment>
      </BrowserRouter>
    );
  }
}

export default graphql(query)(App);


// WEBPACK FOOTER //
// ./src/components/App.js